import React from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import AIChatAssistant from '../components/AIChatAssistant';

/**
 * Assistente técnico geral, sem vínculo ou acesso aos dados dos pacientes.
 */
const AIAnalysisPage = () => {
  const { user } = useAuth();
  const toast = useToast();
  const backendUrl =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:8001'
    : '');
  const token = localStorage.getItem('token') || '';

  return (
    <Layout user={user} title="Assistente Técnico">
      <div className="p-4">
        <div className="max-w-6xl mx-auto mb-4">
          <h1 className="text-2xl font-bold text-gray-900">Assistente Técnico</h1>
          <p className="mt-1 text-sm text-gray-600">Perguntas gerais, sem acesso aos dados dos pacientes.</p>
        </div>
        <AIChatAssistant backendUrl={backendUrl} token={token} toast={toast} />
      </div>
    </Layout>
  );
};

export default AIAnalysisPage;
